import React from 'react';
import NotificationsIcon from 'mdi-react/NotificationsIcon';

import { IconButton } from '@crm-framework/icon-button';

import { INotificationBellProps } from './types';
import {
  NotificationBellWrapper,
  NotificationBellUnreadMessages,
} from './styles';

export const NotificationBell: React.FC<INotificationBellProps> = ({
  unreadMessages,
  unreadMessageStyles,
  limit,
}) => {
  const isVisibleUnreadMessages = unreadMessages > 0;
  const formattedUnreadMessages =
    limit && unreadMessages > limit ? `${limit}+` : unreadMessages;

  return (
    <NotificationBellWrapper>
      <IconButton icon={NotificationsIcon} size="sm" />
      {isVisibleUnreadMessages && (
        <NotificationBellUnreadMessages style={unreadMessageStyles}>
          {formattedUnreadMessages}
        </NotificationBellUnreadMessages>
      )}
    </NotificationBellWrapper>
  );
};
